export default __webpack_public_path__ + "static/media/grid.4b99787b.svg";